<template>
  <oare-content-view title="Site Analytics" :loading="loading">
    <div v-if="production">
      <div>
        <v-card max-height="100%"
          ><iframe
            class="test-iframe"
            width="100%"
            height="1000"
            :src="src"
            frameborder="0"
            style="border: 0"
            allowfullscreen
          ></iframe
        ></v-card>
      </div>
      <div class="pt-4">
        <a
          :href="href"
          target="_blank"
          rel="noopener"
          class="text-decoration-none"
        >
          <v-btn class="test-button">Go to Google Analytics</v-btn>
        </a>
      </div>
    </div>
    <div v-else>
      <span class="test-page-unavailable"
        >This page is only available in production</span
      >
    </div>
  </oare-content-view>
</template>

<script lang="ts">
import OareContentView from '@/components/base/OareContentView.vue';
import { computed, defineComponent, onMounted, ref } from 'vue';
import sl from '@/serviceLocator';

export default defineComponent({
  components: { OareContentView },
  name: 'AnalyticsView',
  setup() {
    const actions = sl.get('globalActions');
    const src = ref('');
    const href = ref('');
    const loading = ref(false);

    const production = computed(() => import.meta.env.MODE === 'production');

    onMounted(async () => {
      loading.value = true;
      try {
        if (production.value) {
          src.value = import.meta.env.VUE_APP_GOOGLE_ANALYTICS_DASHBOARD_SOURCE;
          href.value = import.meta.env.VUE_APP_GOOGLE_ANALYTICS_HREF;
        }
      } catch (err) {
        actions.showErrorSnackbar('Error loading dashboard', err as Error);
      } finally {
        loading.value = false;
      }
    });
    return {
      src,
      href,
      production,
      loading,
    };
  },
});
</script>
